<div class="label-text">
    <p class="{{ getLabelClass() }}">{{ getLabel() }}</p>
    <p class="{{ getTextClass() }}">{{ getText() }}</p>
</div>